// Lib
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Styles
import './Main.scss';

const MainLayout = React.forwardRef(function MainLayout(props, ref) {
    const { className, canvasComponent, inboxComponent } = props;

    return (
        <main ref={ref} className={classNames('Main', className)}>
            <div className="canvas-section">{canvasComponent}</div>
            <div className="inbox-section">{inboxComponent}</div>
        </main>
    );
});

MainLayout.propTypes = {
    className: PropTypes.string,
    canvasComponent: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    inboxComponent: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};

export default MainLayout;
